var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { commonBase } from '@kid/meta-color/color/output/all';
import React from 'react';
import { Animated, Dimensions, StyleSheet, View } from 'react-native';
import { rem } from '../../utils/rem';
import { DialogShow } from '../Dialog';
import { Drag } from '../Drag';
import { DialogComponent } from './components';
const windowWidth = Dimensions.get('window').width;
const styles = StyleSheet.create({
    line: {
        width: rem(48),
        height: rem(4),
        borderRadius: rem(2),
        backgroundColor: commonBase.kiui_color_base_black_1_a12,
    },
});
export const AlertBottomCard = (arg = {}) => {
    const { kid, popupSet, topIconKid, showLine = false, onConfirm = () => { } } = arg, rest = __rest(arg, ["kid", "popupSet", "topIconKid", "showLine", "onConfirm"]);
    let defaultProps = Object.assign(Object.assign({ showButton: false, onCancel: () => {
            alert.close();
        }, position: 'bottom', animate: 'slider', popupStyle: {
            width: windowWidth,
            paddingHorizontal: rem(11),
            backgroundColor: 'rgba(0,0,0,0)',
            bottom: 0,
            paddingTop: rem(12),
        }, maskBgColor: 'rgba(0,0,0,0.3)', popupSet }, popupSet), { width: windowWidth, borderRadius: rem(16), wrapStyle: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        } });
    const renderTop = showLine
        ? () => {
            return React.createElement(View, { style: [styles.line] });
        }
        : undefined;
    const alert = DialogShow(Object.assign(Object.assign(Object.assign({}, defaultProps), rest), { onConfirm: () => {
            var _a;
            (_a = arg === null || arg === void 0 ? void 0 : arg.onConfirm) === null || _a === void 0 ? void 0 : _a.call(arg, {
                close: () => {
                    var _a;
                    (_a = alert === null || alert === void 0 ? void 0 : alert.close) === null || _a === void 0 ? void 0 : _a.call(alert);
                },
            });
        }, renderTop }), DialogComponent);
    return {
        close: () => {
            alert.close();
        },
        update: (props) => {
            const updateProps = Object.assign(Object.assign(Object.assign({}, defaultProps), rest), props);
            alert.update(updateProps);
        },
    };
};
export function AlertBottomCardDragable(props) {
    const { topNode, dragNode, dragDistance, closeWhenReachDistance = true, onDistanceReached } = props, restProps = __rest(props, ["topNode", "dragNode", "dragDistance", "closeWhenReachDistance", "onDistanceReached"]);
    const transY = new Animated.Value(0);
    const dialog = AlertBottomCard(Object.assign(Object.assign({ closeIcon: false, showLine: false, title: null, useModal: false }, restProps), { wrapStyle: Object.assign({ paddingTop: 8 }, (props.wrapStyle || {})), popupStyle: Object.assign(Object.assign({}, (props.popupStyle || {})), { transform: [{ translateY: transY }] }), onAnimateEnd: () => {
            var _a;
            (_a = props === null || props === void 0 ? void 0 : props.onAnimateEnd) === null || _a === void 0 ? void 0 : _a.call(props);
            transY.setValue(0);
        }, content: (React.createElement(React.Fragment, null,
            topNode,
            React.createElement(Drag, { distance: dragDistance, transY: transY, closeWhenReachDistance: closeWhenReachDistance, onDistanceReached: (y) => {
                    onDistanceReached === null || onDistanceReached === void 0 ? void 0 : onDistanceReached(y);
                    if (closeWhenReachDistance) {
                        dialog.close();
                    }
                } }, dragNode), props === null || props === void 0 ? void 0 :
            props.content)) }));
    return dialog;
}
